import Vue from 'vue';

export default class A3Service {
    static async trasmitir(payload) {
        const { ip_app_local, porta_app_local } = Vue.prototype.$usuarioLogado.LojaConfiguracoes
        const urlBaseA3 = `http://${ip_app_local}:${porta_app_local}`

        return await Vue.prototype.$api.axios(
            'cte/conhecimentos/autorizar', 
            payload, 
            'post', 
            urlBaseA3, 
            { 'Content-Type': 'application/json' }
        );
    }

    static async cancelar(payload) {
        const { ip_app_local, porta_app_local } = Vue.prototype.$usuarioLogado.LojaConfiguracoes
        const urlBaseA3 = `http://${ip_app_local}:${porta_app_local}`

        return await Vue.prototype.$api.axios(
            'cte/conhecimentos/cancelar', 
            payload, 
            'post', 
            urlBaseA3, 
            { 'Content-Type': 'application/json' }
        );
    }

    static async enviarCartaCorrecao(payload) {
        const { ip_app_local, porta_app_local } = Vue.prototype.$usuarioLogado.LojaConfiguracoes
        const urlBaseA3 = `http://${ip_app_local}:${porta_app_local}`

        return await Vue.prototype.$api.axios(
            'cte/conhecimentos/enviar-carta-correcao', 
            payload, 
            'post', 
            urlBaseA3, 
            { 'Content-Type': 'application/json' }
        );
    }
}